if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.predictiveSearchResults = this.querySelector('#predictive-search');

      var $this = this;
      this.form.addEventListener('submit', function () {
        $this.submitHandler(event);
      });

      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('focus', this.debounce((event) => {
        if (this.input.value) {
          this.predictiveSearchResults.style.display = 'block';
        }
      }, 100).bind(this));
      this.input.addEventListener('focusout', this.debounce((event) => {
        this.predictiveSearchResults.style.display = 'none';
      }, 300).bind(this));

      var currentURL = window.location.href;
      if (currentURL.indexOf("Phonesell") !== -1) {
        document.querySelector('.search-form__clear-action').addEventListener('click', this.debounce((event) => {
          document.querySelector('.search-form__clear-action').classList.remove('predictive-search__clear-button--visible');
          $this.input.value = '';

          if (this.closest(".search-form__input-wrapper")) {
            var searchElement = this.closest(".search-form__input-wrapper").querySelector('input[type="search"]');

            if (searchElement) {
              searchElement.value = "";
              this.closest(".search-form__input-wrapper").querySelector('.search-form__clear-action').classList.remove('predictive-search__clear-button--visible');
            }
          }

        }, 100).bind(this))

        if ($this.input.value) {
          document.querySelector('.search-form__clear-action').classList.add('predictive-search__clear-button--visible');
        } else {
          document.querySelector('.search-form__clear-action').classList.remove('predictive-search__clear-button--visible');
        }
      }

    }
    submitHandler(event) {
      event.preventDefault();
      const form = event.currentTarget.cloneNode(true);
      const termsInput = form.querySelector('[name=q]');
      form.style.position = 'absolute';
      form.style.left = '-1000px';
      form.style.bottom = '-1000px';
      form.style.visibility = 'hidden';
      let terms = termsInput.value;


      // Add field filter
      // Filter should always come before the input terms,
      // otherwise Shopify won't return the expected results.
      if (!terms.replace(/\s/g, '').length) {
        return false;
      }

      terms = `product_type:Phonesell AND ${terms}`; // Update value

      termsInput.value = terms; // Forms must be in the browser context in order to submit

      window.document.body.appendChild(form);
      form.submit();
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      var currentURL = window.location.href;

      if (currentURL.indexOf("Phonesell") !== -1) {
        if (searchTerm) {
          document.querySelector('.search-form__clear-action').classList.add('predictive-search__clear-button--visible');
        } else {
          document.querySelector('.search-form__clear-action').classList.remove('predictive-search__clear-button--visible');
        }
      }

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      if (!searchTerm.replace(/\s/g, '').length) {
        var terms = `${searchTerm}`;
      } else {
        var terms = `product_type:Phonesell AND ${searchTerm}`;
      }
      fetch(`/search/suggest?q=${encodeURIComponent(terms)}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.predictiveSearchResults.style.display = 'block';
    }

    close() {
      this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
// // ✅ Hide unwanted predictive search results (battery, parts, lcd, etc.)
// // ✅ Hide unwanted predictive search results (repair & parts related)
// document.addEventListener('DOMContentLoaded', () => {
//   const unwantedWords = [
//     'battery',
//     'parts',
//     'lcd',
//     'screen',
//     'replacement',
//     'earpiece',
//     'speaker',
//     'vibrator',
//     'sensor',
//     'camera',
//     'frame',
//     'tool',
//     'toolkit',
//     'housing',
//     'glass',
//     'case',
//     'cover',
//     'button',
//     'charger',
//     'charging',
//     'port',
//     'usb',
//     'dock',
//     'connector',
//     'board',
//     'adhesive',
//     'bracket',
//     'sim',
//     'microphone',
//     'flex',
//     'assembly',
//     'wire',
//     'tape',
//     'display',
//     'module',
//     'screw',
//     'kit',
//     'ear',
//     'vibe',
//     'touch',
//     'power',
//   ];

//   const hideUnwantedResults = () => {
//     const items = document.querySelectorAll('.predictive-search-item');
//     items.forEach(item => {
//       const text = item.textContent.toLowerCase();
//       if (unwantedWords.some(word => text.includes(word))) {
//         console.log("hide", text);
//         item.style.display = 'none';
//       }
//     });
//   };

//   // Run immediately once
//   hideUnwantedResults();

//   // Watch for any predictive search updates
//   const observer = new MutationObserver(hideUnwantedResults);
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Safety recheck every 1s
//   setInterval(hideUnwantedResults, 1000);
// });

